import React, { useEffect } from 'react';

import {
  Alert,
  Button,
  Row,
  Col,
  Form,
  Tab,
} from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import { editConfiguration } from 'apis/admin/configApi';

function DefaultMetaTag({ tabEventKey, metatag, getMetaTagSetting }) {
  const {
    register,
    handleSubmit,
    setValue,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });

  // react-hook-form에 기본 값 설정하기
  useEffect(() => {
    if (metatag) {
      for (const key in metatag) {
        setValue(key, metatag[key]);
      }
    }
  }, [metatag]);

  // 기본 메타태그 설정 저장
  const onSubmit = async (data) => {
    let dataToSubmit = { ...data };
    for (const key in data) {
      if (data[key] !== '') {
        dataToSubmit[key] = data[key].trim();
      }
    }

    await editConfiguration(dataToSubmit)
      .then(async (response) => {
        if (response.data.success) {
          Swal.fire({
            icon: 'success',
            title: '환경 설정 - 메타태그 저장을 완료했습니다.',
          }).then(async () => {
            await getMetaTagSetting();
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: '환경 설정 - 메타태그를 저장할 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        }
      })
      .catch(error => {
        console.error('error occured in MetaTagConfig/DefaultMetaTag.js - onSubmit() ', error);

        Swal.fire({
          icon: 'error',
          title: '환경 설정 - 메타태그를 저장할 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });
  };

  return (
    <Tab.Pane eventKey={tabEventKey}>
      <Alert variant="info" className="mb-4">
        웹 페이지 전반을 나타내는 기본적인 제목(title)과 메타태그(metatag)를 관리하는 페이지입니다.
      </Alert>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            title
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_meta_title_default')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            meta description
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_meta_description_default')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            meta keywords
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_meta_keywords_default')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            page name
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_page_name_default')}
            />
          </Col>
        </Form.Group>
        {/* <Card.Header className="mb-4 pt-6">
          <h3 className="mb-0 ml--4 mt--4">메인 페이지</h3>
        </Card.Header>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            title
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_meta_title_main')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            meta description
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_meta_description_main')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            meta keywords
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_meta_keywords_main')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            page name
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_page_name_main')}
            />
          </Col>
        </Form.Group> */}
        <Row className="justify-content-center pt-5">
          <Button type="submit" variant="primary">
            저장하기
          </Button>
        </Row>
      </Form>
    </Tab.Pane>
  );
}

export default DefaultMetaTag;
